import { EditCenter, EditContainer, EditRight } from '~/view/view.edit';
import { useService } from '~/shared/service/service.base';
import { UIService } from '~/service/service.ui';
import { AuthService } from '~/service/service.auth';
import { SettingsService } from '~/service/service.settings';
import { Form } from '~/shared/form';
import { MaintenanceDto } from '~/shared/dto/admin/settings.dto';
import { FieldSwitch } from '~/view/fields/field.switch';
import { Button, Stack, Typography } from '@mui/material';
import { useNavBack } from '~/app/app.routes';
import { FieldDate } from '~/view/fields/field.date';

export const MaintenancePage = () => {
	const [ui, auth, settingsSvc]  = useService(UIService, AuthService, SettingsService);
	const navBack = useNavBack();

	const form = Form.use(MaintenanceDto, {
		name: 'MaintenanceDto',
		onSubmit: (dto) => settingsSvc.updateMaintenanceMode(dto).then(() => {
			ui.notify('Maintenance mode successfully changed', 'success');
		}),
		initial: () => settingsSvc.getMaintenanceMode(),
	})

	ui.usePageTitle('Maintenance');
	const canSave = auth.can('settings', 'UPDATE');

	return (
		<EditContainer async={settingsSvc.async}>
			<EditCenter>
				<Stack spacing={3}>
					<Typography variant="subtitle1">
						Schedule maintenance mode (optional):
					</Typography>

					<FieldDate
						field={form.$maintenanceStartDate}
					/>

					<FieldDate
						field={form.$maintenanceEndDate}
					/>
				</Stack>
			</EditCenter>
			<EditRight>
				<Button variant="contained" onClick={form.submit} disabled={!canSave}>
					Save
				</Button>
				<br />
				<Button variant="outlined" onClick={navBack}>
					Cancel
				</Button>
				<Button variant="outlined" onClick={form.reset}>
					Reset
				</Button>
			</EditRight>
		</EditContainer>
	)
}
